/**
 * Shop toolbar: filters the server-rendered product list by text and milk and sorts it,
 * all in the page (the whole collection is rendered in one page of up to 250 products).
 * ponytail: no URL state for filters; add ?latte=/?q= if shoppers ask to share filtered lists.
 */
class CollectionFilters extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-filter-grid]');
    if (!this.grid) return;

    this.items = [...this.grid.children];
    this.milk = '';
    this.query = '';
    this.search = this.querySelector('[data-filter-search]');
    this.milkGroup = this.querySelector('[data-filter-milk]');
    this.milkGroup.hidden = false;

    this.querySelector('[data-filter-search-form]').addEventListener('submit', (event) => event.preventDefault());
    this.search.addEventListener('input', () => {
      this.query = this.search.value.trim().toLowerCase();
      this.apply();
    });

    this.milkGroup.addEventListener('click', (event) => {
      const button = event.target.closest('[data-milk]');
      if (button) this.setMilk(button.dataset.milk);
    });

    const sort = this.querySelector('[data-filter-sort]');
    sort.addEventListener('change', () => this.sort(sort.selectedIndex));
    this.querySelector('[data-filter-sort-form]').addEventListener('submit', (event) => event.preventDefault());

    this.querySelectorAll('[data-filter-reset]').forEach((button) => {
      button.addEventListener('click', () => {
        this.search.value = '';
        this.query = '';
        this.setMilk('');
        this.search.focus();
      });
    });
  }

  setMilk(milk) {
    this.milk = milk;
    this.milkGroup.querySelectorAll('[data-milk]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.milk === milk));
    });
    this.apply();
  }

  /** A product with "mucca e pecora" shows under both Mucca and Pecora. */
  apply() {
    let shown = 0;
    this.items.forEach((item) => {
      const visible =
        (!this.milk || item.dataset.milk.includes(this.milk)) && (!this.query || item.dataset.search.includes(this.query));
      item.hidden = !visible;
      if (visible) shown += 1;
    });

    const word = this.querySelector('[data-count-word]');
    this.querySelector('[data-count]').textContent = shown;
    word.textContent = shown === 1 ? word.dataset.one : word.dataset.other;
    this.querySelector('[data-filter-empty]').hidden = shown > 0;
    this.querySelector('.shop-count [data-filter-reset]').hidden = !this.milk && !this.query;
  }

  /** Option order: 0 collection order, 1 price up, 2 price down, 3 name A–Z. */
  sort(index) {
    const price = (item) => Number(item.dataset.price);
    const compare = [
      (a, b) => a.dataset.index - b.dataset.index,
      (a, b) => price(a) - price(b),
      (a, b) => price(b) - price(a),
      (a, b) => a.dataset.title.localeCompare(b.dataset.title, 'it'),
    ][index];
    if (!compare) return;
    this.items.sort(compare).forEach((item) => this.grid.append(item));
  }
}

if (!customElements.get('collection-filters')) customElements.define('collection-filters', CollectionFilters);
